import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["buttonIcon", "buttonIconPosition", "buttonSize", "buttonVariant", "children", "defaultButtonVariant", "disabled", "fullWidth", "href", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Button, TAGLink, TAGSvgIcon } from '../../../';
import { useTheme } from '@mui/material/styles';

var TAGButton = function TAGButton(_ref) {
  var buttonIcon = _ref.buttonIcon,
      buttonIconPosition = _ref.buttonIconPosition,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? 'large' : _ref$buttonSize,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? 'Secondary Default' : _ref$buttonVariant,
      children = _ref.children,
      defaultButtonVariant = _ref.defaultButtonVariant,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var variantMapper = {
    'Primary Default': 'contained',
    'Primary High Contrast': 'contained',
    'Primary Accent01': 'contained',
    'Secondary Default': 'outlined',
    'Secondary High Contrast': 'outlined',
    'Secondary Accent01': 'outlined',
    'Tertiary Default': 'text',
    'Tertiary High Contrast': 'text',
    'Arrow Default': 'text',
    'Arrow High Contrast': 'text'
  };
  var theme = useTheme(); // NOTE: Delete this defaultButtonVariant prop and it's related checks once contentful is cleaned up

  var BaseButton = React.createElement(Button, _objectSpread(_objectSpread({}, props), {}, {
    fullWidth: fullWidth,
    name: variantMapper[buttonVariant] ? buttonVariant : defaultButtonVariant,
    variant: variantMapper[buttonVariant] || defaultButtonVariant && variantMapper[defaultButtonVariant],
    startIcon: buttonIconPosition === 'start' && buttonIcon && React.createElement(TAGSvgIcon, {
      icon: buttonIcon,
      size: 25
    }),
    endIcon: buttonIconPosition === 'end' && buttonIcon && React.createElement(TAGSvgIcon, {
      icon: buttonIcon,
      size: 25
    }),
    disabled: disabled,
    size: buttonSize,
    disableElevation: true,
    disableRipple: true,
    sx: _objectSpread({
      '.MuiButton-startIcon': {
        marginRight: '4px'
      },
      '.MuiButton-endIcon': {
        marginLeft: '4px'
      },
      '& .svg-arrow-button': {
        marginLeft: '10px',
        transition: 'all .2s ease'
      },
      '&:hover .svg-arrow-path, &:active .svg-arrow-path': {
        d: 'path("M50.3536 4.35355C50.5488 4.15829 50.5488 3.84171 50.3536 3.64645L47.1716 0.464466C46.9763 0.269204 46.6597 0.269204 46.4645 0.464466C46.2692 0.659728 46.2692 0.976311 46.4645 1.17157L49.2929 4L46.4645 6.82843C46.2692 7.02369 46.2692 7.34027 46.4645 7.53553C46.6597 7.7308 46.9763 7.7308 47.1716 7.53553L50.3536 4.35355ZM0 4.5H50V3.5H0V4.5Z")',
        transform: 'scaleX(0.627)'
      },
      '&:hover .svg-arrow-button': {
        width: '51px',
        transform: 'scaleY(0.627)'
      },
      '& .svg-arrow-path': {
        transition: 'all .2s ease'
      },
      transition: 'all .2s ease',
      '&:disabled .svg-arrow-button': {
        fill: buttonVariant == 'Arrow Default' ? theme.palette.text.disabled : theme.palette.neutrals.white
      }
    }, sx)
  }), children, (buttonVariant == 'Arrow Default' || buttonVariant == 'Arrow High Contrast') && React.createElement(TAGSvgIcon, {
    icon: "ArrowButton",
    viewBox: "0 0 32 8",
    className: "svg-arrow-button",
    color: buttonVariant == 'Arrow Default' ? theme.palette.primary.main : theme.palette.neutrals.white
  }));

  if (href) {
    return React.createElement(TAGLink, {
      href: href,
      sx: {
        textDecoration: 'none'
      }
    }, BaseButton);
  }

  return BaseButton;
};

export default TAGButton;